import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductCardEntityParams {
  productLineId: number | string;
  indexPosition: number;
  distributors?: object[];
  isPaid?: boolean;
  priceBucket?: number;
  verifiedInStock?: boolean;
  stockStatus?: string;
  futurePriceAvailable?: boolean;
  hasVintages?: boolean;
}
export class ProductCardEntity extends BaseEntityClass {
  productLineId: number | string;
  indexPosition: number;
  distributors?: object[];
  isPaid?: boolean;
  priceBucket?: number;
  verifiedInStock?: boolean;
  stockStatus?: string;
  futurePriceAvailable?: boolean;
  outsideInitialView?: boolean;
  hasVintages?: boolean;

  constructor(params: ProductCardEntityParams) {
    super();
    this.type = "product_card";
    this.entity_version = 6;
    this.productLineId = params.productLineId;
    this.indexPosition = params.indexPosition;
    this.distributors = params.distributors;
    this.priceBucket = params.priceBucket;
    this.verifiedInStock = params.verifiedInStock;
    this.stockStatus = params.stockStatus;
    this.futurePriceAvailable = params.futurePriceAvailable;
    this.hasVintages = params.hasVintages;
  }
}
